import { render, staticRenderFns } from "./PlatformTelegramLimits.vue?vue&type=template&id=374b7dcc&scoped=true&"
import script from "./PlatformTelegramLimits.vue?vue&type=script&lang=js&"
export * from "./PlatformTelegramLimits.vue?vue&type=script&lang=js&"
import style0 from "./PlatformTelegramLimits.vue?vue&type=style&index=0&id=374b7dcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374b7dcc",
  null
  
)

export default component.exports